const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/utils/cases.ts';
import { ArztPartners, Case } from 'App/defs/case';

export const getArztDataFromCase = (
    caseData: Case | undefined,
    type: 'HausAz' | 'EinwAz'
): ArztPartners | undefined => {
    if (!caseData || caseData.arztPartners.length === 0) return undefined;
    return caseData.arztPartners.filter((arztPartner: any) => arztPartner.Type === type)[0];
};
